export const COURSE_DETAIL_COLUMNS = [
     {
          key: 'name',
          label: 'Course Element',
          _props: { className: 'name' },
     },
     {
          key: 'description',
          label: 'Description',
          _props: { className: 'description' },
     },
     {
          key: 'progress',
          label: 'Progress',
     },
     {
          key: 'access',
          label: 'Access',
          _props: { className: 'access' },
     },
];

export const ORDER_SUBSCRIBER_COLUMNS = [
     {
          key: 'selfId',
          label: 'Order',
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
     },
     {
          key: 'status',
          label: 'Status',
     },
     {
          key: 'total',
          label: 'Total',
     },
     {
          key: 'viewDetails',
          label: '',
          filter: false,
          sorter: false,
     },
];

export const ORDER_DETAIL_SUBSCRIBER_COLUMNS = [
     {
          key: 'name',
          label: 'Name',
          filter: false,
          sorter: false,
          _style: { minWidth: '200px' },
          _props: {},
     },
     {
          key: 'price',
          label: 'Price',
          filter: false,
          sorter: false,
          _style: { minWidth: '30px' },
          _props: {},
     },
     {
          key: 'quantity',
          label: 'Seats',
          filter: false,
          sorter: false,
          _style: { minWidth: '30px' },
          _props: {},
     },
     {
          key: 'total',
          label: 'Total',
          filter: false,
          sorter: false,
          _style: { minWidth: '30px' },
          _props: {},
     },
];

export const LESSON_SUBSCRIBER_COLUMNS = [
     {
          key: 'name',
          label: 'Lesson',
          _style: { minWidth: '500px' },
          _props: {},
     },
     {
          key: 'progress',
          label: 'Progress',
          filter: false,
          sorter: false,
          _style: { minWidth: '200px' },
          _props: {},
     },
     {
          key: 'access',
          label: 'Access',
          filter: false,
          sorter: false,
          _style: { minWidth: '150px' },
          _props: {},
     },
];

export const TRAINING_GROUP_DETAILS_COLUMNS = [
     {
          key: 'email',
          label: 'Email',
          _style: { minWidth: '190px' },
          _props: {},
     },
     {
          key: 'firstName',
          label: 'First Name',
          _style: { minWidth: '150px' },
          _props: {},
     },
     {
          key: 'lastName',
          label: 'Last Name',
          _style: { minWidth: '150px' },
          _props: {},
     },
     {
          key: 'orgRole',
          label: 'Role',
          _props: {},
     },
     {
          key: 'numberOfSeatUsed',
          label: 'Seat Used',
          _style: { textAlign: 'center' },
          _props: {},
     },
];

export const REVIEW_ORDER_CHECKOUT_COLUMNS = [
     {
          key: 'name',
          label: 'Name',
     },
     {
          key: 'price',
          label: 'Price',
     },
     {
          key: 'quantity',
          label: 'Seats/Qty',
     },
     {
          key: 'total',
          label: 'Total',
     },
];

export const CART_COLUMNS = [
     {
          key: 'name',
          label: 'Name',
          _style: { minWidth: '200px', maxWidth: '200px' },
     },
     {
          key: 'price',
          label: 'Price',
          _style: { minWidth: '78px' },
     },
     {
          key: 'quantity',
          label: 'Seats',
          _style: { minWidth: '135 px' },
     },
     {
          key: 'total',
          label: 'Total',
          _style: { minWidth: '115px' },
     },
     {
          key: 'action',
          label: '',
          _style: { minWidth: '105px' },
     },
];

export const ORDER_ORGANIZATION_COLUM = [
     {
          key: 'selfId',
          label: 'Order',
          _style: { minWidth: '120px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '160px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '160px' },
     },
     {
          key: 'total',
          label: 'Total',
          _style: { minWidth: '160px' },
     },
     {
          key: 'viewDetails',
          label: '',
          _style: { width: '25%' },
          filter: false,
          sorter: false,
     },
];

export const ORDER_SOW_ORGANIZATION_COLUM = [
     {
          key: 'selfId',
          label: 'Order',
          _style: { minWidth: '120px' },
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '160px' },
     },
     {
          key: 'status',
          label: 'Status',
          _style: { minWidth: '160px' },
     },
     {
          key: 'total',
          label: 'Total',
          _style: { minWidth: '160px' },
     },
     {
          key: 'viewDetails',
          label: '',
          _style: { width: '25%' },
          filter: false,
          sorter: false,
     },
];

export const ORDER_DETAILS_ORGANIZATION_COLUMNS = [
     {
          key: 'name',
          label: 'Name',
          filter: false,
          sorter: false,
          _style: { minWidth: '200px' },
          _props: {},
     },
     {
          key: 'price',
          label: 'Price',
          filter: false,
          sorter: false,
          _style: { minWidth: '30px' },
          _props: {},
     },
     {
          key: 'quantity',
          label: 'Seats/Qty',
          filter: false,
          sorter: false,
          _style: { minWidth: '30px' },
          _props: {},
     },
     {
          key: 'total',
          label: 'Total',
          filter: false,
          sorter: false,
          _style: { minWidth: '30px' },
          _props: {},
     },
];
export const ORDER_REFUND_ORGANIZATION_COLUM = [
     {
          key: 'selfId',
          label: 'Refund ID',
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
     },
     {
          key: 'status',
          label: 'Status',
     },
     {
          key: 'total',
          label: 'Total',
     },
     {
          key: 'viewDetails',
          label: '',
          filter: false,
          sorter: false,
     },
];

export const ORDER_REFUND_SUBSCRIBER_COLUMNS = [
     {
          key: 'selfId',
          label: 'Refund ID',
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
     },
     {
          key: 'status',
          label: 'Status',
     },
     {
          key: 'total',
          label: 'Total',
     },
     {
          key: 'viewDetails',
          label: '',
          filter: false,
          sorter: false,
     },
];

export const VOUCHERS_SUBSCRIBER_COLUMNS = [
     {
          key: 'code',
          label: 'Voucher Code',
          _style: { minWidth: '250px' },
          sorter: false,
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
     },
     {
          key: 'expirationAt',
          label: 'Expiration Date',
     },
     {
          key: 'status',
          label: 'Status',
          sorter: false,
     },
     {
          key: 'discountValue',
          label: 'Discount',
          sorter: false,
     },
     {
          key: 'viewDetails',
          label: '',
          filter: false,
          sorter: false,
     },
];

export const VOUCHERS_ORGANIZATION_COLUMNS = [
     {
          key: 'code',
          label: 'Voucher Code',
          _style: { minWidth: '250px' },
          sorter: false,
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
     },
     {
          key: 'expirationAt',
          label: 'Expiration Date',
     },
     {
          key: 'status',
          label: 'Status',
          sorter: false,
     },
     {
          key: 'discountValue',
          label: 'Discount',
          sorter: false,
     },
     {
          key: 'viewDetails',
          label: '',
          filter: false,
          sorter: false,
     },
];
